/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ProductState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '@a/store/utils';

export const state: ProductState = {
  orderProduct: { ...getDefaultState() },
};

const namespaced = true;

export const product: Module<ProductState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
